/*

highlight v3  !! Modified by Jon Raasch (http://jonraasch.com) to fix IE6 bug !!

Highlights arbitrary terms.

<http://johannburkard.de/blog/programming/javascript/highlight-javascript-text-higlighting-jquery-plugin.html>

MIT license.

Johann Burkard
<http://johannburkard.de>
<mailto:jb@eaio.com>

*/

jQuery.fn.highlight = function(pat) {
    function innerHighlight(node, pat) {
     let skip = 0;
     if (node.nodeType == 3) {
      let pos = node.data.toUpperCase().indexOf(pat);
      if (pos >= 0) {
       let spannode = document.createElement('span');
       spannode.className = 'highlight';
       let middlebit = node.splitText(pos);
       let middleclone = middlebit.cloneNode(true);
       spannode.appendChild(middleclone);
       middlebit.parentNode.replaceChild(spannode, middlebit);
       skip = 1;
      }
     }
     else if (node.nodeType == 1 && node.childNodes && !/(script|style)/i.test(node.tagName)) {
       let i = 0;
       let childNodes = node.childNodes;
    
       while (i < childNodes.length) {
        i += innerHighlight(childNodes[i], pat);
        i++;
       }
      }
     return skip;
   }
    return this.each(function() {
     innerHighlight(this, pat.toUpperCase());
    });
   };
   
   jQuery.fn.removeHighlight = function() {
    function newNormalize(node) {
       let i = 0;
       let children = node.childNodes;
       let nodeCount = children.length;
   
       while (i < nodeCount) {
           let child = children[i];
           if (child.nodeType == 1) {
               newNormalize(child);
               i++;
               continue;
           }
           if (child.nodeType != 3) {
               i++;
               continue;
           }
           let next = child.nextSibling;
           if (next == null || next.nodeType != 3) {
               i++;
               continue;
           }
           let combined_text = child.nodeValue + next.nodeValue;
           let new_node = node.ownerDocument.createTextNode(combined_text);
           node.insertBefore(new_node, child);
           node.removeChild(child);
           node.removeChild(next);
           nodeCount -= 2;
       }
    }
   
    return this.find("span.highlight").each(function() {
       let thisParent = this.parentNode;
       thisParent.replaceChild(this.firstChild, this);
       newNormalize(thisParent);
    }).end();
   };